import { render, staticRenderFns } from "./LoadingIcon.vue?vue&type=template&id=6a4c70ba&scoped=true"
import script from "./LoadingIcon.vue?vue&type=script&lang=ts"
export * from "./LoadingIcon.vue?vue&type=script&lang=ts"
import style0 from "./LoadingIcon.vue?vue&type=style&index=0&id=6a4c70ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4c70ba",
  null
  
)

export default component.exports